import React, { useState, useEffect } from "react";
import AllTestsPerformanceReportTabel from "../../../parentContentComponent/allTestsPerformanceReportTabel/AllTestsPerformanceReportTabel";
import TestWiseDashboard from "../testwise/TestWiseDashboard";
import "./AnalysisPage.css";
import { useHistory } from "react-router-dom";

const AnalysisPage = ({
  allTests,
  handleStep2,
  setPaperId,
  setPlannerTestId,
  setPapers,
  setSinglePaper,
  studentRollNum,
}) => {
  const history = useHistory();

  const [activeTab, setActiveTab] = useState("overall");
  const [selectedTest, setSelectedTest] = useState(null);

  useEffect(() => {
    if (allTests && allTests.length > 0) {
      setSelectedTest(allTests[0]);
    }
  }, [allTests]);

  const handleTestSelect = (e) => {
    const testId = e.target.value;
    const test = allTests.find((t) => t.paper_id == testId);
    setSelectedTest(test);
  };

  const handleRedirect = () => {
    history.push({
      pathname: "/student-tests",
      state: { step: 1, roll_no: studentRollNum },
    });
  };

  return (
  <div className="analytics-container">
  <div className="tabs-header">
    <div className="tabs">
      <button
        className={`tab ${activeTab === "overall" ? "active" : ""}`}
        onClick={() => setActiveTab("overall")}
      >
        Overall Analysis
      </button>

      <button
        className={`tab ${activeTab === "testwise" ? "active" : ""}`}
        onClick={() => setActiveTab("testwise")}
      >
        Test-Wise Analysis
      </button>
    </div>

    {activeTab === "testwise" && (
      <button className="view-all-btn" onClick={handleRedirect}>
        View all Tests
      </button>
    )}
  </div>

  <div className="content-box">
    {activeTab === "overall" && <AllTestsPerformanceReportTabel />}
    {activeTab === "testwise" && (
      <TestWiseDashboard
        allTests={allTests}
        setPaperId={setPaperId}
        setPlannerTestId={setPlannerTestId}
        setPapers={setPapers}
        setSinglePaper={setSinglePaper}
        handleStep2={handleStep2}
      />
    )}
  </div>
</div>

  );
};

export default AnalysisPage;
